import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../core/api.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { UtilityService } from '../../../core/global/utility.service';
@Component({
  selector: 'app-user-qr-generator-model',
  templateUrl: './user-qr-generator-model.component.html',
  styleUrls: ['./user-qr-generator-model.component.sass']
})
export class UserQrGeneratorModelComponent implements OnInit {
  userList=[];
  userId:string=''
  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, private _adminService: ApiService, private _functions: FunctionsService, private _utility: UtilityService) { }

  ngOnInit(): void {
    this.userId = window.localStorage.getItem('pushUserId');
    window.localStorage.removeItem('pushUserId');
    this.getUserLog()
  }
  getUserLog() {
    let url = "qr/user_log_details";
    let data = { user_id:this.userId };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.userList = response.data;
      } else {
        this._utility.toastError(response.message);
      }
    })
  }
}
